import React, { forwardRef } from "react";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";
import micIcon from "../../Asset/mic.svg";

export const DemoButton = forwardRef(function DemoButton(
  { text, view, className = "" },
  ref
) {
  const animClass =
    view === undefined
      ? ""
      : view
      ? " anim-preserve scale-100 transition-transform duration-[600ms] ease-out opacity-100"
      : "opacity-0 scale-50";

  return (
    <div ref={ref} className={animClass}>
      <NavLink
        to="/demo"
        className={`bg-gradient-to-r font-inter from-[#3AB1F6] to-[#407BFF] hover:from-[#3AA6E4] hover:to-[#4175EB] transition-all duration-300 ease-in-out text-white leading-none lg:text-[18px] md:text-base text-sm w-max p-2 flex items-center gap-2 rounded-full font-semibold ${className}`}
      >
        <span className="bg-white lg:p-2 p-1.5 rounded-full">
          <ReactSVG
            src={micIcon}
            beforeInjection={(svg) => {
              svg.setAttribute("class", "lg:w-5 w-4 lg:h-5 h-4");
            }}
          />
        </span>
        <span className="pl-2 pr-6">{text}</span>
      </NavLink>
    </div>
  );
});
